import _ from "underscore";
import PointerHelper from "./Pointer";

("use strict");

const SkyObjectObservation = {
  greekLetterEntityMap: {
    $a: "Alpha",
    $b: "Beta",
    $c: "Chi",
    $d: "Delta",
    $e: "Epsilon",
    $f: "Phi",
    $g: "Gamma",
    $h: "Eta",
    $i: "Iota",
    $j: "Alpha",
    $k: "Kappa",
    $l: "Lambda",
    $m: "Mu",
    $n: "Nu",
    $o: "Omicron",
    $p: "Pi",
    $q: "Theta",
    $r: "Rho",
    $s: "Sigma",
    $t: "Tau",
    $u: "Upsilon",
    $v: "Alpha",
    $w: "Omega",
    $x: "Xi",
    $y: "Psi",
    $z: "Zet",
  },

  objectCodeTypeMap: {
    xxxx: "Kind_AnyType",
    xxxX: "Kind_Unknown",
    xxxU: "Kind_UserPlanet",

    Cxxx: "Kind_StarGrouping",
    CAxx: "Kind_Asterism",
    CCxx: "Kind_Constellation",
    CSxx: "Kind_SmallStarGrouping",

    sxxx: "Kind_SolarSystemObject",
    sSxx: "Kind_Sun",
    sPxx: "Kind_Planet",
    sEPx: "Kind_Exoplanet",
    sCxx: "Kind_Comet",

    sAxx: "Kind_Asteroid",

    sALx: "Kind_InferiorAsteroid",
    sALV: "Kind_InferiorAsteroidVulcanoid",
    sALM: "Kind_InferiorAsteroidMercuryCrosser",
    sALE: "Kind_InferiorAsteroidVenusCrosser",

    sAEx: "Kind_NearEarthAsteroid",
    sAEI: "Kind_NearEarthAsteroidInteriorEarth",
    sAEt: "Kind_NearEarthAsteroidAten",
    sAEp: "Kind_NearEarthAsteroidApollo",
    sAEm: "Kind_NearEarthAsteroidAmor",

    sAMx: "Kind_MarsCrosserAsteroid",
    sAMt: "Kind_MarsTrojanAsteroid",

    sAIx: "Kind_InnerBeltAsteroid",
    sAII: "Kind_InnerBeltAsteroidMainBeltI",

    sABx: "Kind_MainBeltAsteroid",
    sABa: "Kind_MainBeltAsteroidIIa",
    sABb: "Kind_MainBeltAsteroidIIb",

    sAOx: "Kind_OuterBeltAsteroid",
    sAOa: "Kind_OuterBeltAsteroidIIIa",
    sAOb: "Kind_OuterBeltAsteroidIIIb",

    sASx: "Kind_SuperiorAsteroid",
    sASh: "Kind_SuperiorAsteroidHungaria",
    sASp: "Kind_SuperiorAsteroidPhocaea",

    sASa: "Kind_SuperiorAsteroidAlinda",
    sASl: "Kind_SuperiorAsteroidPallas",
    sASg: "Kind_SuperiorAsteroidGriqua",
    sASc: "Kind_SuperiorAsteroidCybele",
    sASi: "Kind_SuperiorAsteroidHilda",

    sAJt: "Kind_JupiterTrojan",
    sAJe: "Kind_JupiterTrojanEast",
    sAJw: "Kind_JupiterTrojanWest",

    sAFx: "Kind_BeyondJupiterAsteroid",
    sAFc: "Kind_BeyondJupiterAsteroidCentaur",

    sANx: "Kind_TNOAsteroid",
    sANK: "Kind_TNOKuiperBeltAsteroid",
    sANp: "Kind_TNOKuiperBeltPlutino",
    sANc: "Kind_TNOKuiperBeltCubewano",
    sANs: "Kind_TNOAsteroidScatteredDisk",
    sANO: "Kind_TNOAsteroidOortCloud",

    sMxx: "Kind_MoonOfPlanet",
    sMix: "Kind_MinorMoonOfPlanet",
    ssxx: "Kind_MeteorShower",
    sOxx: "Kind_Planetoid",
    sDxx: "Kind_DwarfPlanet",

    Sxxx: "Kind_Star",
    SMxx: "Kind_MultipleStar",
    SM2x: "Kind_DoubleStar",
    SM3x: "Kind_TripleStar",
    SxxV: "Kind_VariableStar",
    SMxV: "Kind_VariableAndMultiple",
    SxxP: "Kind_StarWithExoplanet",
    Sx2P: "Kind_StarWithMultiExoplanet",

    Gxxx: "Kind_Galaxy",

    GBxx: "Kind_BarredSpiralGalaxy",
    GBax: "Kind_BarredSpiralSBaGalaxy",
    GBab: "Kind_BarredSpiralSBabGalaxy",
    GBbx: "Kind_BarredSpiralSBbGalaxy",
    GBbc: "Kind_BarredSpiralSBbcGalaxy",
    GBcx: "Kind_BarredSpiralSBcGalaxy",
    GBcd: "Kind_BarredSpiralSBcdGalaxy",
    GBdx: "Kind_BarredSpiralSBdGalaxy",
    GBmx: "Kind_BarredSpiralSBmGalaxy",

    GCxx: "Kind_GalaxyCluster",
    GCGx: "Kind_GalaxyGroup",
    GCGS: "Kind_GalaxySubgroup",
    GCFx: "Kind_GalaxyFilament",
    GCFa: "Kind_GalaxyFamily",

    GExx: "Kind_EllipticalGalaxy",
    "GEe-": "Kind_EllipticalEMinusGalaxy",
    GEe0: "Kind_EllipticalE0Galaxy",
    "GEe+": "Kind_EllipticalEPlusGalaxy",
    "GES-": "Kind_EllipticalS0MinusGalaxy",
    GLS0: "Kind_LenticularS0Galaxy",
    "GLS+": "Kind_LenticularS0PlusGalaxy",
    GTS0: "Kind_TransitionS0",

    GSxx: "Kind_SpiralGalaxy",
    GSSa: "Kind_SpiralSaGalaxy",
    GSSA: "Kind_SpiralSabGalaxy",
    GSSb: "Kind_SpiralSbGalaxy",
    GSSB: "Kind_SpiralSbcGalaxy",
    GSSc: "Kind_SpiralScGalaxy",
    GSSC: "Kind_SpiralScdGalaxy",
    GSSd: "Kind_SpiralSdGalaxy",

    GIxx: "Kind_IregularGalaxy",
    GISd: "Kind_IregularSpiralSdmGalaxy",
    GISm: "Kind_IregularSpiralSmGalaxy",
    GImx: "Kind_IregularImGalaxy",
    GI0x: "Kind_IregularI0Galaxy",

    Nxxx: "Kind_Nebula",
    NDxx: "Kind_DiffuseNebula",
    Ndxx: "Kind_DarkNebula",
    NPxx: "Kind_PlanetaryNebula",
    NRxx: "Kind_ReflectionNebula",

    Kxxx: "Kind_ClusterOfStars",
    KGxx: "Kind_GlobularCluster",
    KOxx: "Kind_OpenCluster",
    KNxx: "Kind_ClusterWithNebulosity",

    Oxxx: "Kind_Other",
    OGxx: "Kind_Globules",
    OHxx: "Kind_H2Region",
    OQxx: "Kind_Quasar",
    ORxx: "Kind_RadioSource",
    ONxx: "Kind_SupernovaRemnant",
    OBxx: "Kind_BlackHole",

    Xxxx: "Kind_Nonexistant",

    Mxxx: "Kind_ManmadeObject",
    MSxx: "Kind_Satellite",
    MSGx: "Kind_GeosyncSatellite",
    MSAx: "Kind_AstroObsSatellite",
    MPxx: "Kind_Probe",
    MMxx: "Kind_MannedSpacecraft",

    Zxxx: "Kind_SpotSelection",

    // new
    SM2V: "Kind_VariableAndDouble",
    SxxS: "Kind_Supernova",

    OXxx: "Kind_XRaySource",
    OMxx: "Kind_GammaSource",

    Fxxx: "Kind_Feature",

    SxxX: "Kind_NonexistentStar",
  },

  // objectTypeCodeMap: {
  //   'Kind_AnyType': 'xxxx',
  //   'Kind_Unknown': 'xxxX',
  //   'Kind_UserPlanet': 'xxxU',

  //   'Kind_StarGrouping': 'Cxxx',
  //   'Kind_Asterism': 'CAxx',
  //   'Kind_Asterisim': 'CAxx',
  //   'Kind_Constellation': 'CCxx',
  //   'Kind_SmallStarGrouping': 'CSxx',

  //   'Kind_SolarSystemObject': 'sxxx',
  //   'Kind_Sun': 'sSxx',
  //   'Kind_Planet': 'sPxx',
  //   'Kind_Exoplanet': 'sEPx',
  //   'Kind_Comet': 'sCxx',

  //   'Kind_Asteroid': 'sAxx',

  //   'Kind_InferiorAsteroid': 'sALx',
  //   'Kind_InferiorAsteroidVulcanoid': 'sALV',
  //   'Kind_InferiorAsteroidMercuryCrosser': 'sALM',
  //   'Kind_InferiorAsteroidVenusCrosser': 'sALE',

  //   'Kind_NearEarthAsteroid': 'sAEx',
  //   'Kind_NearEarthAsteroidInteriorEarth': 'sAEI',
  //   'Kind_NearEarthAsteroidAten': 'sAEt',
  //   'Kind_NearEarthAsteroidApollo': 'sAEp',
  //   'Kind_NearEarthAsteroidAmor': 'sAEm',

  //   'Kind_MarsCrosserAsteroid': 'sAMx',
  //   'Kind_MarsTrojanAsteroid': 'sAMt',

  //   'Kind_InnerBeltAsteroid': 'sAIx',
  //   'Kind_InnerBeltAsteroidMainBeltI': 'sAII',

  //   'Kind_MainBeltAsteroid': 'sABx',
  //   'Kind_MainBeltAsteroidIIa': 'sABa',
  //   'Kind_MainBeltAsteroidIIb': 'sABb',

  //   'Kind_OuterBeltAsteroid': 'sAOx',
  //   'Kind_OuterBeltAsteroidIIIa': 'sAOa',
  //   'Kind_OuterBeltAsteroidIIIb': 'sAOb',

  //   'Kind_SuperiorAsteroid': 'sASx',
  //   'Kind_SuperiorAsteroidHungaria': 'sASh',
  //   'Kind_SuperiorAsteroidPhocaea': 'sASp',

  //   'Kind_SuperiorAsteroidAlinda': 'sASa',
  //   'Kind_SuperiorAsteroidPallas': 'sASl',
  //   'Kind_SuperiorAsteroidGriqua': 'sASg',
  //   'Kind_SuperiorAsteroidCybele': 'sASc',
  //   'Kind_SuperiorAsteroidHilda': 'sASi',

  //   'Kind_JupiterTrojan': 'sAJt',
  //   'Kind_JupiterTrojanEast': 'sAJe',
  //   'Kind_JupiterTrojanWest': 'sAJw',

  //   'Kind_BeyondJupiterAsteroid': 'sAFx',
  //   'Kind_BeyondJupiterAsteroidCentaur': 'sAFc',

  //   'Kind_TNOAsteroid': 'sANx',
  //   'Kind_TNOKuiperBeltAsteroid': 'sANK',
  //   'Kind_TNOKuiperBeltPlutino': 'sANp',
  //   'Kind_TNOKuiperBeltCubewano': 'sANc',
  //   'Kind_TNOAsteroidScatteredDisk': 'sANs',
  //   'Kind_TNOAsteroidOortCloud': 'sANO',

  //   'Kind_MoonOfPlanet': 'sMxx',
  //   'Kind_MinorMoonOfPlanet': 'sMix',
  //   'Kind_MeteorShower': 'ssxx',
  //   'Kind_Planetoid': 'sOxx',
  //   'Kind_DwarfPlanet': 'sDxx',

  //   'Kind_Star': 'Sxxx',
  //   'Kind_MultipleStar': 'SMxx',
  //   'Kind_DoubleStar': 'SM2x',
  //   'Kind_TripleStar': 'SM3x',
  //   'Kind_VariableStar': 'SxxV',
  //   'Kind_VariableAndMultiple': 'SMxV',
  //   'Kind_StarWithExoplanet': 'SxxP',
  //   'Kind_StarWithMultiExoplanet': 'Sx2P',

  //   'Kind_Galaxy': 'Gxxx',

  //   'Kind_BarredSpiralGalaxy': 'GBxx',
  //   'Kind_BarredSpiralSBaGalaxy': 'GBax',
  //   'Kind_BarredSpiralSBabGalaxy': 'GBab',
  //   'Kind_BarredSpiralSBbGalaxy': 'GBbx',
  //   'Kind_BarredSpiralSBbcGalaxy': 'GBbc',
  //   'Kind_BarredSpiralSBcGalaxy': 'GBcx',
  //   'Kind_BarredSpiralSBcdGalaxy': 'GBcd',
  //   'Kind_BarredSpiralSBdGalaxy': 'GBdx',
  //   'Kind_BarredSpiralSBmGalaxy': 'GBmx',

  //   'Kind_GalaxyCluster': 'GCxx',
  //   'Kind_GalaxyGroup': 'GCGx',
  //   'Kind_GalaxySubgroup': 'GCGS',
  //   'Kind_GalaxyFilament': 'GCFx',
  //   'Kind_GalaxyFamily': 'GCFa',

  //   'Kind_EllipticalGalaxy': 'GExx',
  //   'Kind_EllipticalEMinusGalaxy': 'GEe-',
  //   'Kind_EllipticalE0Galaxy': 'GEe0',
  //   'Kind_EllipticalEPlusGalaxy': 'GEe+',
  //   'Kind_EllipticalS0MinusGalaxy': 'GES-',
  //   'Kind_LenticularS0Galaxy': 'GLS0',
  //   'Kind_LenticularS0PlusGalaxy': 'GLS+',
  //   'Kind_TransitionS0': 'GTS0',

  //   'Kind_SpiralGalaxy': 'GSxx',
  //   'Kind_SpiralSaGalaxy': 'GSSa',
  //   'Kind_SpiralSabGalaxy': 'GSSA',
  //   'Kind_SpiralSbGalaxy': 'GSSb',
  //   'Kind_SpiralSbcGalaxy': 'GSSB',
  //   'Kind_SpiralScGalaxy': 'GSSc',
  //   'Kind_SpiralScdGalaxy': 'GSSC',
  //   'Kind_SpiralSdGalaxy': 'GSSd',

  //   'Kind_IregularGalaxy': 'GIxx',
  //   'Kind_IregularSpiralSdmGalaxy': 'GISd',
  //   'Kind_IregularSpiralSmGalaxy': 'GISm',
  //   'Kind_IregularImGalaxy': 'GImx',
  //   'Kind_IregularI0Galaxy': 'GI0x',

  //   'Kind_Nebula': 'Nxxx',
  //   'Kind_DiffuseNebula': 'NDxx',
  //   'Kind_DarkNebula': 'Ndxx',
  //   'Kind_PlanetaryNebula': 'NPxx',
  //   'Kind_ReflectionNebula': 'NRxx',

  //   'Kind_ClusterOfStars': 'Kxxx',
  //   'Kind_GlobularCluster': 'KGxx',
  //   'Kind_OpenCluster': 'KOxx',
  //   'Kind_ClusterWithNebulosity': 'KNxx',

  //   'Kind_Other': 'Oxxx',
  //   'Kind_Globules': 'OGxx',
  //   'Kind_H2Region': 'OHxx',
  //   'Kind_Quasar': 'OQxx',
  //   'Kind_RadioSource': 'ORxx',
  //   'Kind_SupernovaRemnant': 'ONxx',
  //   'Kind_BlackHole': 'OBxx',

  //   'Kind_Nonexistant': 'Xxxx',

  //   'Kind_ManmadeObject': 'Mxxx',
  //   'Kind_Satellite': 'MSxx',
  //   'Kind_GeosyncSatellite': 'MSGx',
  //   'Kind_AstroObsSatellite': 'MSAx',
  //   'Kind_Probe': 'MPxx',
  //   'Kind_MannedSpacecraft': 'MMxx',

  //   'Kind_SpotSelection': 'Zxxx',

  //   // new
  //   'Kind_VariableAndDouble': 'SM2V',
  //   'Kind_Supernova': 'SxxS',

  //   'Kind_XRaySource': 'OXxx',
  //   'Kind_GammaSource': 'OMxx',

  //   'Kind_Feature': 'Fxxx',

  //   'Kind_NonexistentStar': 'SxxX'
  // },

  objectCodeDisplayMap: {
    xxxx: "Any Type",
    xxxX: "Unknown",
    xxxU: "User Planet",

    Cxxx: "Star Grouping",
    CAxx: "Asterism",
    CCxx: "Constellation",
    CSxx: "Small Star Grouping",

    sxxx: "Solar System Object",
    sSxx: "Sun",
    sPxx: "Planet",
    sEPx: "Exoplanet",
    sCxx: "Comet",

    sAxx: "Asteroid",

    sALx: "Inferior Asteroid",
    sALV: "Inferior Asteroid Vulcanoid",
    sALM: "Inferior Asteroid Mercury-Crosser",
    sALE: "Inferior Asteroid Venus-Crosser",

    sAEx: "Near Earth Asteroid",
    sAEI: "Near Earth Asteroid Interior Earth",
    sAEt: "Near Earth Asteroid Aten",
    sAEp: "Near Earth Asteroid Apollo",
    sAEm: "Near Earth Asteroid Amor",

    sAMx: "Mars Crosser Asteroid",
    sAMt: "Mars Trojan Asteroid",

    sAIx: "Inner Belt Asteroid",
    sAII: "Inner Belt Asteroid Main Belt I",

    sABx: "Main Belt Asteroid",
    sABa: "Main Belt Asteroid IIa",
    sABb: "Main Belt Asteroid IIb",

    sAOx: "Outer Belt Asteroid",
    sAOa: "Outer Belt Asteroid IIIa",
    sAOb: "Outer Belt Asteroid IIIb",

    sASx: "Superior Asteroid",
    sASh: "Superior Asteroid Hungaria",
    sASp: "Superior Asteroid Phocaea",

    sASa: "Superior Asteroid Alinda",
    sASl: "Superior Asteroid Pallas",
    sASg: "Superior Asteroid Griqua",
    sASc: "Superior Asteroid Cybele",
    sASi: "Superior Asteroid Hilda",

    sAJt: "Jupiter Trojan",
    sAJe: "Jupiter Trojan East",
    sAJw: "Jupiter Trojan West",

    sAFx: "Beyond Jupiter Asteroid",
    sAFc: "Beyond Jupiter Asteroid Centaur",

    sANx: "TNO Asteroid",
    sANK: "TNO Kuiper Belt Asteroid",
    sANp: "TNO Kuiper Belt Plutino",
    sANc: "TNO Kuiper Belt Cubewano",
    sANs: "TNO Asteroid Scattered Disk",
    sANO: "TNO Asteroid Oort Cloud",

    sMxx: "Moon Of Planet",
    sMix: "Minor Moon Of Planet",
    ssxx: "Meteor Shower",
    sOxx: "Planetoid",
    sDxx: "Dwarf Planet",

    Sxxx: "Star",
    SMxx: "Multiple Star",
    SM2x: "Double Star",
    SM3x: "Triple Star",
    SxxV: "Variable Star",
    SMxV: "Variable And Multiple",
    SxxP: "Star With Exoplanet",
    Sx2P: "Star With Multi Exoplanet",

    Gxxx: "Galaxy",

    GBxx: "Barred Spiral Galaxy",
    GBax: "Barred Spiral SBa Galaxy",
    GBab: "Barred Spiral SBab Galaxy",
    GBbx: "Barred Spiral SBb Galaxy",
    GBbc: "Barred Spiral SBbc Galaxy",
    GBcx: "Barred Spiral SBc Galaxy",
    GBcd: "Barred Spiral SBcd Galaxy",
    GBdx: "Barred Spiral SBd Galaxy",
    GBmx: "Barred Spiral SBm Galaxy",

    GCxx: "Galaxy Cluster",
    GCGx: "Galaxy Group",
    GCGS: "Galaxy Subgroup",
    GCFx: "Galaxy Filament",
    GCFa: "Galaxy Family",

    GExx: "Elliptical Galaxy",
    "GEe-": "Elliptical E Minus Galaxy",
    GEe0: "Elliptical E0 Galaxy",
    "GEe+": "Elliptical E Plus Galaxy",
    "GES-": "Elliptical S0 Minus Galaxy",
    GLS0: "Lenticular S0 Galaxy",
    "GLS+": "Lenticular S0 Plus Galaxy",
    GTS0: "Transition S0",

    GSxx: "Spiral Galaxy",
    GSSa: "Spiral Sa Galaxy",
    GSSA: "Spiral SAb Galaxy",
    GSSb: "Spiral Sb Galaxy",
    GSSB: "Spiral SBc Galaxy",
    GSSc: "Spiral Sc Galaxy",
    GSSC: "Spiral SCd Galaxy",
    GSSd: "Spiral Sd Galaxy",

    GIxx: "Iregular Galaxy",
    GISd: "Iregular Spiral Sdm Galaxy",
    GISm: "Iregular Spiral Sm Galaxy",
    GImx: "Iregular Im Galaxy",
    GI0x: "Iregular I0 Galaxy",

    Nxxx: "Nebula",
    NDxx: "Diffuse Nebula",
    Ndxx: "Dark Nebula",
    NPxx: "Planetary Nebula",
    NRxx: "Reflection Nebula",

    Kxxx: "Cluster Of Stars",
    KGxx: "Globular Cluster",
    KOxx: "Open Cluster",
    KNxx: "Cluster With Nebulosity",

    Oxxx: "Other",
    OGxx: "Globules",
    OHxx: "H2 Region",
    OQxx: "Quasar",
    ORxx: "Radio Source",
    ONxx: "Supernova Remnant",
    OBxx: "BlackHole",

    Xxxx: "Nonexistant",

    Mxxx: "Manmade Object",
    MSxx: "Satellite",
    MSGx: "Geosync Satellite",
    MSAx: "Astro Obs Satellite",
    MPxx: "Probe",
    MMxx: "Manned Spacecraft",

    Zxxx: "Spot Selection",

    // new
    SM2V: "Variable And Double",
    SxxS: "Supernova",

    OXxx: "X-Ray Source",
    OMxx: "Gamma Source",

    Fxxx: "Feature",

    SxxX: "Nonexistent Star",
  },

  objectCodeImageMap: {
    xxxx: "star", // 'Any Type'
    xxxX: "star", // 'Unknown'
    xxxU: "planet", // 'User Planet'

    Cxxx: "", // 'Star Grouping'
    CAxx: "asterism", // 'Asterism'
    CCxx: "constellation", // 'Constellation'
    CSxx: "", // 'Small Star Grouping'

    sxxx: "", // 'Solar System Object'
    sSxx: "", // 'Sun'
    sPxx: "planet", // 'Planet'
    sEPx: "planet", // 'Exoplanet'
    sCxx: "comet", // 'Comet'

    sAxx: "", // 'Asteroid'

    sALx: "", // 'Inferior Asteroid'
    sALV: "", // 'Inferior Asteroid Vulcanoid'
    sALM: "", // 'Inferior Asteroid Mercury-Crosser'
    sALE: "", // 'Inferior Asteroid Venus-Crosser'

    sAEx: "", // 'Near Earth Asteroid'
    sAEI: "", // 'Near Earth Asteroid Interior Earth'
    sAEt: "", // 'Near Earth Asteroid Aten'
    sAEp: "", // 'Near Earth Asteroid Apollo'
    sAEm: "", // 'Near Earth Asteroid Amor'

    sAMx: "", // 'Mars Crosser Asteroid'
    sAMt: "", // 'Mars Trojan Asteroid'

    sAIx: "", // 'Inner Belt Asteroid '
    sAII: "", // 'Inner Belt Asteroid Main Belt I'

    sABx: "", // 'Main Belt Asteroid'
    sABa: "", // 'Main Belt Asteroid IIa'
    sABb: "", // 'Main Belt Asteroid IIb'

    sAOx: "", // 'Outer Belt Asteroid '
    sAOa: "", // 'Outer Belt Asteroid IIIa'
    sAOb: "", // 'Outer Belt Asteroid IIIb'

    sASx: "", // 'Superior Asteroid '
    sASh: "", // 'Superior Asteroid Hungaria'
    sASp: "", // 'Superior Asteroid Phocaea'

    sASa: "", // 'Superior Asteroid Alinda'
    sASl: "", // 'Superior Asteroid Pallas'
    sASg: "", // 'Superior Asteroid Griqua'
    sASc: "", // 'Superior Asteroid Cybele'
    sASi: "", // 'Superior Asteroid Hilda'

    sAJt: "", // 'Jupiter Trojan'
    sAJe: "", // 'Jupiter Trojan East'
    sAJw: "", // 'Jupiter Trojan West'

    sAFx: "", // 'Beyond Jupiter Asteroid'
    sAFc: "", // 'Beyond Jupiter Asteroid Centaur'

    sANx: "", // 'TNO Asteroid'
    sANK: "", // 'TNO Kuiper Belt Asteroid'
    sANp: "", // 'TNO Kuiper Belt Plutino'
    sANc: "", // 'TNO Kuiper Belt Cubewano'
    sANs: "", // 'TNO Asteroid Scattered Disk'
    sANO: "", // 'TNO Asteroid Oort Cloud'

    sMxx: "moon", // 'Moon Of Planet'
    sMix: "moon", // 'Minor Moon Of Planet'
    ssxx: "meteorshower", // 'Meteor Shower'
    sOxx: "planet", // 'Planetoid'
    sDxx: "planet", // 'Dwarf Planet'

    Sxxx: "star", // 'Star'
    SMxx: "star", // 'Multiple Star'
    SM2x: "doublestar", // 'Double Star'
    SM3x: "star", // 'Triple Star'
    SxxV: "variablestar", // 'Variable Star'
    SMxV: "variablestar", // 'Variable And Multiple'
    SxxP: "star", // 'Star With Exoplanet'
    Sx2P: "star", // 'Star With Multi Exoplanet'

    Gxxx: "galaxy", // 'Galaxy'

    GBxx: "galaxy", // 'Barred Spiral Galaxy'
    GBax: "galaxy", // 'Barred Spiral SBa Galaxy'
    GBab: "galaxy", // 'Barred Spiral SBab Galaxy'
    GBbx: "galaxy", // 'Barred Spiral SBb Galaxy'
    GBbc: "galaxy", // 'Barred Spiral SBbc Galaxy'
    GBcx: "galaxy", // 'Barred Spiral SBc Galaxy'
    GBcd: "galaxy", // 'Barred Spiral SBcd Galaxy'
    GBdx: "galaxy", // 'Barred Spiral SBd Galaxy'
    GBmx: "galaxy", // 'Barred Spiral SBm Galaxy'

    GCxx: "galaxy", // 'Galaxy Cluster'
    GCGx: "galaxy", // 'Galaxy Group'
    GCGS: "galaxy", // 'Galaxy Subgroup'
    GCFx: "galaxy", // 'Galaxy Filament'
    GCFa: "galaxy", // 'Galaxy Family'

    GExx: "galaxy", // 'Elliptical Galaxy'
    "GEe-": "galaxy", // 'Elliptical E Minus Galaxy'
    GEe0: "galaxy", // 'Elliptical E0 Galaxy'
    "GEe+": "galaxy", // 'Elliptical E Plus Galaxy'
    "GES-": "galaxy", // 'Elliptical S0 Minus Galaxy'
    GLS0: "galaxy", // 'Lenticular S0 Galaxy'
    "GLS+": "galaxy", // 'Lenticular S0 Plus Galaxy'
    GTS0: "galaxy", // 'Transition S0'

    GSxx: "galaxy", // 'Spiral Galaxy'
    GSSa: "galaxy", // 'Spiral Sa Galaxy'
    GSSA: "galaxy", // 'Spiral SAb Galaxy'
    GSSb: "galaxy", // 'Spiral Sb Galaxy'
    GSSB: "galaxy", // 'Spiral SBc Galaxy'
    GSSc: "galaxy", // 'Spiral Sc Galaxy'
    GSSC: "galaxy", // 'Spiral SCd Galaxy'
    GSSd: "galaxy", // 'Spiral Sd Galaxy'

    GIxx: "galaxy", // 'Iregular Galaxy'
    GISd: "galaxy", // 'Iregular Spiral Sdm Galaxy'
    GISm: "galaxy", // 'Iregular Spiral Sm Galaxy'
    GImx: "galaxy", // 'Iregular Im Galaxy'
    GI0x: "galaxy", // 'Iregular I0 Galaxy'

    Nxxx: "galacticnebula", // 'Nebula'
    NDxx: "galacticnebula", // 'Diffuse Nebula'
    Ndxx: "darknebula", // 'Dark Nebula'
    NPxx: "planetarynebula", // 'Planetary Nebula'
    NRxx: "galacticnebula", // 'Reflection Nebula'

    Kxxx: "opencluster", // 'Cluster Of Stars'
    KGxx: "globularcluster", // 'Globular Cluster'
    KOxx: "opencluster", // 'Open Cluster'
    KNxx: "opencluster", // 'Cluster With Nebulosity'

    Oxxx: "", // 'Other'
    OGxx: "", // 'Globules'
    OHxx: "", // 'H2 Region'
    OQxx: "quasar", // 'Quasar'
    ORxx: "", // 'Radio Source'
    ONxx: "supernovaremnant", // 'Supernova Remnant'
    OBxx: "", // 'BlackHole'

    Xxxx: "", // 'Nonexistant'

    Mxxx: "", // 'Manmade Object'
    MSxx: "satellite", // 'Satellite'
    MSGx: "satellite", // 'Geosync Satellite'
    MSAx: "satellite", // 'Astro Obs Satellite'
    MPxx: "", // 'Probe'
    MMxx: "", // 'Manned Spacecraft'

    Zxxx: "", // 'Spot Selection'

    // new
    SM2V: "doublevariablestar", // 'Variable And Double'
    SxxS: "", // 'Supernova'

    OXxx: "", // 'X-Ray Source'
    OMxx: "", // 'Gamma Source'

    Fxxx: "feature", // 'Feature'

    SxxX: "", // 'Nonexistent Star
  },

  getSkyObjectObservationsByPointerId: (id, fieldName) => {
    // fieldName is the column to lookup on
    var skyObjectObservations = _.filter(
      Portal.Current.Collections.skyObjectObservations,
      (skyObjectObservation) => {
        if (
          skyObjectObservation.get(fieldName) &&
          skyObjectObservation.get(fieldName).id === id
        ) {
          return skyObjectObservation;
        }
      },
    );
    return skyObjectObservations;
  },

  getSkyObjectObservationsByEquipment: (equipment) => {
    var equipmentType =
      PointerHelper.SkyObjectObservation[equipment.get("type")];
    var id = equipment.id;

    // get all observations which have this equipment type
    var skyObjectObservationsWithThisEquipmentType = _.filter(
      Portal.Current.Collections.skyObjectObservations,
      (skyObjectObservation) => {
        if (skyObjectObservation?.get("equipment")?.[equipmentType]) {
          return skyObjectObservation;
        }
      },
    );

    // further filter which have this equipment id
    var skyObjectsWithThisEquipment = _.filter(
      // query the collection of observations which have this equipment type
      skyObjectObservationsWithThisEquipmentType,
      function (skyObjectObservation) {
        // return observations which used this piece of equipment
        var found = _.find(
          skyObjectObservation.get("equipment")[this],
          (equipment) => {
            if (equipment.objectId === id) {
              return equipment;
            }
          },
        );
        return !!found;
      },
      equipmentType,
    );

    return skyObjectsWithThisEquipment;
  },

  getDisplayName: function (skyObject) {
    var delimiter = "%%";
    var rawName = "";
    var entityMap = this.greekLetterEntityMap;

    if (!_.isEmpty(skyObject.name)) {
      // check for a name first
      rawName = skyObject.name;
    } else if (!_.isEmpty(skyObject.commonNames)) {
      // check commonNames and return the first item
      rawName = skyObject.commonNames.split(delimiter)[0];
    } else if (!_.isEmpty(skyObject.catalogNumbers)) {
      // check catalogNumbers and return the first item
      rawName = skyObject.catalogNumbers.split(delimiter)[0];
    }

    // tokens look like $a, $b, etc
    return rawName.replace(/\$[a-z]/g, (matched) => entityMap[matched]);
  },

  getDisplayType: function (skyObject) {
    var objectType = "";
    var typeDisplayMap = this.objectCodeDisplayMap;

    if (!_.isEmpty(skyObject.type)) {
      // check for a type
      objectType = skyObject.type;
    }

    return typeDisplayMap[objectType];
  },

  getImageFileName: function (skyObject) {
    var imageFileName = "";

    // check if an object type is defined
    if (
      !_.isEmpty(skyObject.type) &&
      !_.isEmpty(this.objectCodeImageMap[skyObject.type])
    ) {
      imageFileName = `generic_${this.objectCodeImageMap[skyObject.type]}.png`;
    }
    return imageFileName;
  },

  getCatalogNumberByIndex: function (skyObject, index) {
    var delimiter = "%%";
    var entityMap = this.greekLetterEntityMap;
    var objectName;

    if (!_.isEmpty(skyObject.catalogNumbers)) {
      // check catalogNumbers and return the item at the index
      objectName = skyObject.catalogNumbers.split(delimiter)[index];
    }

    if (objectName) {
      // tokens look like $a, $b, etc
      return objectName.replace(/\$[a-z]/g, (matched) => entityMap[matched]);
    }

    return objectName;
  },

  // aladinGoToObject: function (aladin, objectName, skyObject, index) {
  //   var that = this

  //   index = index || 0

  //   aladin.gotoObject(objectName,
  //     // error callback
  //     function () {
  //       console.log('not found or another error occurred... trying next catalog number')
  //       index++ // try next in index
  //       objectName = that.getCatalogNumberByIndex(skyObject, index)
  //       if (objectName) {
  //         console.log('trying goto: ' + objectName)
  //         that.aladinGoToObject(aladin, objectName, skyObject, index)
  //       }
  //     }
  //   )
  // },

  // showDSSImage: function (skyObject, elementSelector) {
  //   var objectName = this.getCatalogNumberByIndex(skyObject, 0) // get the first catalog number
  //   var aladin = window.A.aladin(elementSelector, {
  //     survey: 'P/DSS2/color',
  //     showReticle: false,
  //     showZoomControl: false,
  //     showFullscreenControl: false,
  //     showLayersControl: false,
  //     showGotoControl: false,
  //     showShareControl: false,
  //     showFrame: false,
  //     zoom: 0.7135613708071721
  //   })

  //   if (objectName) {
  //     console.log('goto: ' + objectName)
  //     this.aladinGoToObject(aladin, objectName, skyObject)
  //   }

  //   aladin.setFOVRange(0.01, 103)
  // }
};

export default SkyObjectObservation;
